// 代交车首页筛选数据
const deliveryAgent = {
  state: {
    deliveryAgentFilter: {
      deliveryCode: '',
      carNo: '',
      vinCode: '',
      clientName: '',
      expectedPickerName: '',
      takerJobNumber: '',
      deliverCarDate: [],
      appointmentTimeBegin: '',
      appointmentTimeEnd: '',
      currentBtnIndex: 0
    },
    isDeliveryAgentDetail: false
  },
  mutations: {
    setDeliveryAgentFilter(state, payload) {
      state.deliveryAgentFilter = payload
    },
    setIsDeliveryAgentDetail(state, payload) {
      state.isDeliveryAgentDetail = payload
    }
  }
}

export default deliveryAgent



// WEBPACK FOOTER //
// ./src/store/model/deliveryAgent.js